import React from "react";
import { Nav, ListGroup } from "react-bootstrap";
import Logout from "../views/Account/Logout";
import PropTypes from "prop-types";

export const ListGroupItem = ({ to, active, title, icon, isMobile, isLoading,
  renderLogoutButton,
  menu }) => {
  const Icon = icon;

  const isExternalLink = to.startsWith("http") || to.startsWith("https");

  return (
    <ListGroup.Item
      as={isExternalLink ? "a" : Nav.Link}
      href={to}
      to={isExternalLink ? undefined: to}
      active={active}
      target={isExternalLink ? "_blank" : undefined}
      rel={isExternalLink ? "noopener noreferrer" : undefined}
      className={
        isMobile
          ? `bottom-sidebar-item bottom-sidebar-link ${active && "active"}`
          : "d-flex align-items-center gap-2"
      }
    >
      {(isMobile && title !== 'Log out') ? (
        <div className="bottom-sidebar-icon">
          {icon ? <Icon className="hamberger-icon" /> : null}
        </div>
      ) : (
        <></>
      )}
      {!isLoading && renderLogoutButton && menu && title === 'Log out' && (
        <Logout isMobileView={true} />
      )}
      <div className="bottom-sidebar-text">{title}</div>
    </ListGroup.Item>
  );
};

ListGroupItem.propTypes = {
  to: PropTypes.string.isRequired,
  active: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.elementType,
  isMobile: PropTypes.bool,
  isLoading: PropTypes.bool,
  renderLogoutButton: PropTypes.any,
  menu: PropTypes.any
};
